
export default {
  name: 'page404',
  mounted() {
   window.location.href = '/'
  }
}
